// Get campaigns
export const getAllCampaigns = (payload) => ({ payload, type: 'GET_ALL_CAMPAIGNS' });
export const setAllCampaigns = (payload) => ({ payload, type: 'SET_ALL_CAMPAIGNS' });

// Single campaign
export const getSingleCampaign = (payload) => ({ payload, type: 'GET_SINGLE_CAMPAIGN' });
export const setSingleCampaign = (payload) => ({ payload, type: 'SET_SINGLE_CAMPAIGN' });

// Create campaign
export const createCampaign = (payload) => ({ payload, type: 'CREATE_CAMPAIGN' });

// Update campaign
export const updateCampaign = (payload) => ({ payload, type: 'UPDATE_CAMPAIGN' });

// Delete campaign
export const deleteCampaign = (payload) => ({ payload, type: 'DELETE_CAMPAIGN' });

// Duplicate campaign
export const duplicateCampaign = (payload) => ({ payload, type: 'DUPLICATE_CAMPAIGN' });

// Campaign lifecycle
export const launchCampaign = (payload) => ({ payload, type: 'LAUNCH_CAMPAIGN' });
export const pauseCampaign = (payload) => ({ payload, type: 'PAUSE_CAMPAIGN' });
export const resumeCampaign = (payload) => ({ payload, type: 'RESUME_CAMPAIGN' });
export const completeCampaign = (payload) => ({ payload, type: 'COMPLETE_CAMPAIGN' });

// Test campaign
export const sendTestCampaign = (payload) => ({ payload, type: 'SEND_TEST_CAMPAIGN' });
export const sendTestNode = (payload) => ({ payload, type: 'SEND_TEST_NODE' });
export const setTestCampaignProgress = (payload) => ({ payload, type: 'SET_TEST_CAMPAIGN_PROGRESS' });
export const resetTestCampaign = () => ({ type: 'RESET_TEST_CAMPAIGN' });

// Content Analysis & Improvement
export const analyzeContent = (payload, callback) => ({ payload, callback, type: 'ANALYZE_CONTENT' });
export const setContentAnalysis = (payload) => ({ payload, type: 'SET_CONTENT_ANALYSIS' });
export const autoImproveContent = (payload, callback) => ({ payload, callback, type: 'AUTO_IMPROVE_CONTENT' });
export const setAutoImproveResult = (payload) => ({ payload, type: 'SET_AUTO_IMPROVE_RESULT' });
export const setAnalyzing = (payload) => ({ payload, type: 'SET_ANALYZING' });
export const setAutoImproving = (payload) => ({ payload, type: 'SET_AUTO_IMPROVING' });

// AI Generation
export const generateCampaign = (payload) => ({ payload, type: 'GENERATE_CAMPAIGN' });

// Analytics
export const getCampaignAnalytics = (payload) => ({ payload, type: 'GET_CAMPAIGN_ANALYTICS' });
export const setCampaignAnalytics = (payload) => ({ payload, type: 'SET_CAMPAIGN_ANALYTICS' });
export const getActivityFeed = (payload) => ({ payload, type: 'GET_ACTIVITY_FEED' });
export const setActivityFeed = (payload) => ({ payload, type: 'SET_ACTIVITY_FEED' });
export const getCampaignAuditLog = (payload) => ({ payload, type: 'GET_CAMPAIGN_AUDIT_LOG' });
export const setCampaignAuditLog = (payload) => ({ payload, type: 'SET_CAMPAIGN_AUDIT_LOG' });
export const getDashboardStats = () => ({ type: 'GET_DASHBOARD_STATS' });
export const setDashboardStats = (payload) => ({ payload, type: 'SET_DASHBOARD_STATS' });

// Campaign Contacts & Execution
export const getCampaignContacts = (payload) => ({ payload, type: 'GET_CAMPAIGN_CONTACTS' });
export const setCampaignContacts = (payload) => ({ payload, type: 'SET_CAMPAIGN_CONTACTS' });
export const getCampaignContactStats = (payload) => ({ payload, type: 'GET_CAMPAIGN_CONTACT_STATS' });
export const setCampaignContactStats = (payload) => ({ payload, type: 'SET_CAMPAIGN_CONTACT_STATS' });
export const setCampaignExecutionProgress = (payload) => ({ payload, type: 'SET_CAMPAIGN_EXECUTION_PROGRESS' });

// Templates
export const getCampaignTemplates = (payload) => ({ payload, type: 'GET_CAMPAIGN_TEMPLATES' });
export const setCampaignTemplates = (payload) => ({ payload, type: 'SET_CAMPAIGN_TEMPLATES' });
export const getCampaignTemplate = (payload) => ({ payload, type: 'GET_CAMPAIGN_TEMPLATE' });
export const setCampaignTemplate = (payload) => ({ payload, type: 'SET_CAMPAIGN_TEMPLATE' });

// UI State
export const setCampaignFilters = (payload) => ({ payload, type: 'SET_CAMPAIGN_FILTERS' });
export const setCampaignBuilderModal = (payload) => ({ payload, type: 'SET_CAMPAIGN_BUILDER_MODAL' });
export const setSelectedStep = (payload) => ({ payload, type: 'SET_SELECTED_STEP' });

// Sequence builder
export const setSequenceNodes = (payload) => ({ payload, type: 'SET_SEQUENCE_NODES' });
export const setSequenceEdges = (payload) => ({ payload, type: 'SET_SEQUENCE_EDGES' });
export const setSelectedNode = (payload) => ({ payload, type: 'SET_CAMPAIGN_SELECTED_NODE' });

// Loading states
export const setCampaignLoading = (payload) => ({ payload, type: 'SET_CAMPAIGN_LOADING' });
export const setCampaignError = (payload) => ({ payload, type: 'SET_CAMPAIGN_ERROR' });

// Milo AI Chat
export const startMiloSession = (payload) => ({ payload, type: 'START_MILO_SESSION' });
export const setMiloSession = (payload) => ({ payload, type: 'SET_MILO_SESSION' });
export const sendMiloMessage = (payload) => ({ payload, type: 'SEND_MILO_MESSAGE' });
export const setMiloMessages = (payload) => ({ payload, type: 'SET_MILO_MESSAGES' });
export const addMiloMessage = (payload) => ({ payload, type: 'ADD_MILO_MESSAGE' });
export const setMiloSuggestions = (payload) => ({ payload, type: 'SET_MILO_SUGGESTIONS' });
export const setMiloLoading = (payload) => ({ payload, type: 'SET_MILO_LOADING' });
export const setMiloAgentActions = (payload) => ({ payload, type: 'SET_MILO_AGENT_ACTIONS' });
export const addMiloAgentAction = (payload) => ({ payload, type: 'ADD_MILO_AGENT_ACTION' });
export const clearMiloAgentActions = () => ({ type: 'CLEAR_MILO_AGENT_ACTIONS' });
export const resetMiloSession = () => ({ type: 'RESET_MILO_SESSION' });
export const clearMiloConversation = (payload) => ({ payload, type: 'CLEAR_MILO_CONVERSATION' });
export const generateMiloTemplate = (payload) => ({ payload, type: 'GENERATE_MILO_TEMPLATE' });
export const generatePersonalizedMessage = (payload) => ({ payload, type: 'GENERATE_PERSONALIZED_MESSAGE' });
export const generatePersonalizedMessageStream = (payload) => ({ payload, type: 'GENERATE_PERSONALIZED_MESSAGE_STREAM' });
export const setStreamingText = (payload) => ({ payload, type: 'SET_STREAMING_TEXT' });
export const setPersonalizedMessageResult = (payload) => ({ payload, type: 'SET_PERSONALIZED_MESSAGE_RESULT' });
export const setSelectedTestContact = (payload) => ({ payload, type: 'SET_SELECTED_TEST_CONTACT' });
export const setPersonalizationLoading = (payload) => ({ payload, type: 'SET_PERSONALIZATION_LOADING' });

// AI Variables
export const runAIVariables = (payload) => ({ payload, type: 'RUN_AI_VARIABLES' });
export const setAIVariablesLoading = (payload) => ({ payload, type: 'SET_AI_VARIABLES_LOADING' });
export const setAIVariablesResult = (payload) => ({ payload, type: 'SET_AI_VARIABLES_RESULT' });
export const saveAIVariableKeys = (payload) => ({ payload, type: 'SAVE_AI_VARIABLE_KEYS' });
export const getAIVariableKeyStatus = (payload) => ({ payload, type: 'GET_AI_VARIABLE_KEY_STATUS' });
export const setAIVariableKeyStatus = (payload) => ({ payload, type: 'SET_AI_VARIABLE_KEY_STATUS' });
export const getAIVariableColumns = (payload) => ({ payload, type: 'GET_AI_VARIABLE_COLUMNS' });
export const setAudienceColumnVisibility = (payload) => ({ payload, type: 'SET_AUDIENCE_COLUMN_VISIBILITY' });
export const updateAudienceColumnVisibility = (payload) => ({ payload, type: 'UPDATE_AUDIENCE_COLUMN_VISIBILITY' });

// Legacy exports for backward compatibility with Email pages
export const registerGAccounts = (payload) => ({ payload, type: 'REGISTER_G_ACCOUNTS' });
export const registerAppPassAccounts = (payload) => ({ payload, type: 'REGISTER_APP_PASS_ACCOUNTS' });
export const getAllInboxes = (payload) => ({ payload, type: 'GET_ALL_INBOXES' });
export const getAllEmailCampaign = (payload) => ({ payload, type: 'GET_ALL_EMAIL_CAMPAIGN' });
export const getAllCampaign = (payload) => ({ payload, type: 'GET_ALL_CAMPAIGN_LEGACY' });
export const getAllMails = (payload) => ({ payload, type: 'GET_ALL_MAILS' });
export const replyToUserEmail = (payload) => ({ payload, type: 'REPLY_TO_USER_EMAIL' });
export const createTask = (payload) => ({ payload, type: 'CREATE_TASK' });
export const createEmailTask = (payload) => ({ payload, type: 'CREATE_EMAIL_TASK' });
export const updateTask = (payload) => ({ payload, type: 'UPDATE_TASK' });
export const updateStatus = (payload) => ({ payload, type: 'UPDATE_STATUS' });
export const getCampaignLogs = (payload) => ({ payload, type: 'GET_CAMPAIGN_LOGS' });
export const deleteSingleCampaign = (payload) => ({ payload, type: 'DELETE_SINGLE_CAMPAIGN' });
export const getSingleTask = (payload) => ({ payload, type: 'GET_SINGLE_TASK' });
export const createScheduleEmail = (payload) => ({ payload, type: 'CREATE_SCHEDULE_EMAIL' });
